import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import SoftBox from "components/SoftBox";
import { Icon } from "@mui/material";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";

function SubCategoryPopup({ item, open, onClose, handleRefresh, fromAdmin }) {
    const AppService = useAppServices();
    const [agency, Update] = useAgencyInfo();
    const [waitingAdd, setWaitingAdd] = useState(false);
    const [waitingSave, setWaitingSave] = useState(false);
    const [newSubCategory, setNewSubCategory] = useState({ id: "", name: "" });
    const [selectedSubs, setSelectedSubs] = useState([]);

    useEffect(() => {
        if (!agency?.SubCategories) return;

        if (fromAdmin) {
            const tagRecords = item?.superadmin_template_cats?.filter(r => r.type === 'tag') || [];
            const existing = agency.SubCategories.filter(sub =>
                (!sub.agency_id || sub.agency_id === agency._id) &&
                tagRecords.some(r => r.item_id === sub._id?.toString() || r.item_id === sub.id)
            );
            setSelectedSubs(existing);
        } else {
            if (item?.subCategory) {
                const existing = agency.SubCategories
                    .filter(sub => !sub.agency_id || sub.agency_id === agency._id)
                    .filter(sub => item.subCategory.some(selected => selected.id === sub.id));
                setSelectedSubs(existing);
            } else {
                setSelectedSubs([]);
            }
        }
    }, [agency?.SubCategories, item?.subCategory, item?.superadmin_template_cats, agency._id, fromAdmin]);

    const handleCreateSubCategory = async (e) => {
        e.preventDefault();
        if (!newSubCategory.name) return;

        setWaitingAdd(true);

        const subCategoryWithAgencyId = { ...newSubCategory, agency_id: agency._id };
        const payload = {
            _id: agency._id,
            SubCategories: [...(agency?.SubCategories || []), subCategoryWithAgencyId],
        };

        const updatedAgency = await AppService.agency.update({ payload, toaster: true });
        if (updatedAgency) {
            setNewSubCategory({ id: "", name: "" });
            Update(updatedAgency?.response?.data);
        }
        setWaitingAdd(false);
    };

    const handleSubmitSelection = async (e) => {
        e.preventDefault();
        setWaitingSave(true);

        if (fromAdmin) {
            const item_ids = selectedSubs.map(sub => sub._id?.toString() || sub.id);
            const { response } = await AppService.superadmin_template_categories.save({
                payload: { template_id: item._id, agency_id: agency._id, type: 'tag', item_ids },
                toaster: true,
            });
            if (response) {
                handleRefresh();
                onClose();
            }
        } else {
            const subCategoriesWithAgencyId = selectedSubs.map(sub => ({
                ...sub,
                agency_id: agency._id,
            }));
            const payload = { _id: item._id, subCategory: subCategoriesWithAgencyId };
            const { response } = await AppService.promptslabel.update({ payload, toaster: true });
            if (response) {
                handleRefresh();
                onClose();
            }
        }

        setWaitingSave(false);
    };

    const updateAgencySubCategories = async (updatedSubCategories) => {
        const payload = { _id: agency._id, SubCategories: updatedSubCategories };
        try {
            const { response } = await AppService.agency.update({ payload, toaster: true });
            if (response) Update(response.data);
        } catch (error) {
            console.log('An error occurred');
        }
    };

    const handleDelete = (id) => {
        const updated = agency?.SubCategories.filter(cat => cat.id !== id);
        updateAgencySubCategories(updated);
    };

    return (
        <>
            {open && (
                <div className="modal-zz-confirm text-left">
                    <div className="p-2 scrollable-modal-content bg-white rounded" style={{ position: "relative" }}>
                        <h2 className="text-black text-left font-14" style={{ fontWeight: "700", marginBottom: "10px" }}>
                            Manage Tags
                        </h2>
                        <span className="crossison" onClick={onClose}>X</span>

                        <div style={{ display: "flex", flexDirection: "column", gap: "10px", height: "200px", overflowY: "auto" }}>
                            {agency?.SubCategories
                                ?.filter(sub => sub.agency_id === agency._id)
                                ?.map((sub, index) => (
                                    <label key={index} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px", border: "1px solid #ccc", borderRadius: "5px" }}>
                                        <span style={{ display: "flex", alignItems: "center", gap: "8px", height: '20px' }}>
                                            <input
                                                type="checkbox"
                                                checked={selectedSubs.some(s => s.id === sub.id)}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setSelectedSubs([...selectedSubs, { ...sub, agency_id: agency._id }]);
                                                    } else {
                                                        setSelectedSubs(selectedSubs.filter(s => s.id !== sub.id));
                                                    }
                                                }}
                                            />
                                            {sub.name}
                                        </span>
                                        <p className="cursor-pointer" onClick={() => handleDelete(sub.id)}><Icon>delete</Icon></p>
                                    </label>
                                ))}
                        </div>

                        <SoftBox component="form" onSubmit={handleCreateSubCategory} mt={2} mb={2}>
                            <input
                                placeholder="New Tag Name"
                                style={{ width: "100%", padding: "8px", marginBottom: "8px", borderRadius: '5px' }}
                                value={newSubCategory.name}
                                onChange={(e) => setNewSubCategory({ id: Date.now().toString(), name: e.target.value })}
                                disabled={waitingAdd}
                            />
                            <button
                                style={{ background: 'white', color: 'black', border: '1px solid #ccc', padding: '10px 16px', borderRadius: '5px', opacity: waitingAdd ? 0.6 : 1, cursor: waitingAdd ? 'not-allowed' : 'pointer' }}
                                className="w-100"
                                type="submit"
                                disabled={waitingAdd || !newSubCategory.name}
                            >
                                {waitingAdd ? (
                                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <span className="spinner" style={{ width: '16px', height: '16px', marginRight: '8px' }}></span> Adding...
                                    </span>
                                ) : "Add Tag"}
                            </button>
                        </SoftBox>

                        <SoftBox mt={2}>
                            <button
                                className="savebtn-setting w-100"
                                type="button"
                                disabled={waitingSave}
                                onClick={handleSubmitSelection}
                                style={{ opacity: waitingSave ? 0.6 : 1, cursor: waitingSave ? 'not-allowed' : 'pointer' }}
                            >
                                {waitingSave ? (
                                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <span className="spinner" style={{ width: '16px', height: '16px', marginRight: '8px' }}></span> Saving...
                                    </span>
                                ) : "Save Tags"}
                            </button>
                        </SoftBox>
                    </div>
                </div>
            )}
        </>
    );
}

SubCategoryPopup.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    handleRefresh: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
    fromAdmin: PropTypes.bool,
};

function AddSubCategoryPrompt({ handleRefresh, item, fromAdmin }) {
    const [open, setOpen] = useState(false);

    return (
        <>
            <span style={{ cursor: 'pointer' }} onClick={() => setOpen(true)}>
                <Icon>edit</Icon>
            </span>
            <SubCategoryPopup item={item} open={open} onClose={() => setOpen(false)} handleRefresh={handleRefresh} fromAdmin={fromAdmin} />
        </>
    );
}

AddSubCategoryPrompt.propTypes = {
    handleRefresh: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
    fromAdmin: PropTypes.bool,
};

export default AddSubCategoryPrompt;
